/**
 *
 * Live stream script
 *
 */

jQuery(document).ready(function () {

    $('.video-thumb').click(function(){
    	$(this).hide();
    });


});